import React, { useCallback } from 'react'
import './KeyTitleLabel.css';

export default function KeyTitleLabel({title='', setEditMode, isLocked, isSuccess, isCustom}) {

  const handleClick = useCallback(() => {
    setEditMode();
  }, [setEditMode]);

  //---[ Render ]---

  return (
    <div className={`keyTitleLabel ${isLocked ? 'keyTitleLocked':'keyTitleEditable'} ${isSuccess ? 'keyTitleSuccess': 'keyTitleNormal'} ${isCustom ? 'customTitle' : ''}`} onClick={handleClick}>
      {title}
    </div>
  )
}
